import React from "react";
import { Box, Typography } from "@mui/material";

const RelatorioEstoqueHeaderTable = () => {

    return (
        <>
            <Box className="relatorio-header-table">
                <Box>
                    <Typography className="relatorio-header-column">Código</Typography>
                </Box>

                <Box>
                    <Typography className="relatorio-header-column nome-produto-column">Nome Produto</Typography>
                </Box>

                <Box>
                    <Typography className="relatorio-header-column">Físico</Typography>
                </Box>

                <Box>
                    <Typography className="relatorio-header-column">Reserv</Typography>
                </Box>

                <Box>
                    <Typography className="relatorio-header-column">Saldo</Typography>
                </Box>
            </Box>
        </>
    )
}

export default RelatorioEstoqueHeaderTable;